import { render, staticRenderFns } from "./SiatLetturaPianiSceltaComponent.vue?vue&type=template&id=60960523&scoped=true"
import script from "./SiatLetturaPianiSceltaComponent.vue?vue&type=script&lang=js"
export * from "./SiatLetturaPianiSceltaComponent.vue?vue&type=script&lang=js"
import style0 from "./SiatLetturaPianiSceltaComponent.vue?vue&type=style&index=0&id=60960523&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "60960523",
  null
  
)

export default component.exports